import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '<',
        roles: '<',
        levels: '<',
        planningGroup: '<',
        exceptionTargets: '<',
        courseExceptionTargets: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.close()"></button>
            <h2>{{ 'courses.Exceptions' | translate }}</h2>
        </div>
        <div class="modal-body">
            <list-empty ng-if="!vm.PlanningGroupTargetService.availableTargets.length" list="vm.PlanningGroupTargetService.availableTargets" show-add-message="false"></list-empty>
            <div ng-if="vm.PlanningGroupTargetService.availableTargets.length" class="dataTables_wrapper">
                <table class="data01">
                    <thead>
                        <tr role="row">
                            <th class="w1p checkbox sorting_disabled" rowspan="1" colspan="1">
                                <input ng-click="vm.PlanningGroupTargetService.toggleAll()" ng-model="vm.PlanningGroupTargetService.checked" type="checkbox">
                            </th>
                            <th>{{ 'employee.First Name' | translate }}</th>
                            <th>{{ 'employee.Last Name' | translate }}</th>
                            <th>{{ 'employee.Position' | translate }}</th>
                            <th>{{ 'courses.Need' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="target in vm.PlanningGroupTargetService.availableTargets">
                            <td class="w1p checkbox">
                                <input
                                    ng-checked="vm.PlanningGroupTargetService.hasTarget(target.id)"
                                    type="checkbox"
                                    ng-click="$event.stopPropagation();vm.PlanningGroupTargetService.toggleTarget(target.id)"
                                >
                            </td>
                            <td>{{ target.employee.firstName }}</td>
                            <td>{{ target.employee.lastName }}</td>
                            <td>
                                <p ng-repeat="drl in target.employee.drlsWithValue">{{ drl.departmentName }}, {{ drl.roleName }}, {{ drl.levelName }}</p>
                            </td>
                            <td>{{ vm.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.LABELS[target.type] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button ng-if="vm.PlanningGroupTargetService.selectedTargetIds.length" class="btn main" type="button" ng-click="vm.save()">
                        {{ 'general.Add' | translate }}
                    </button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (PlanningGroupTargetService, COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM) {
        this.PlanningGroupTargetService = PlanningGroupTargetService;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
    }

    $onInit () {
        this.PlanningGroupTargetService.setPlanningGroup(this.planningGroup);
        this.PlanningGroupTargetService.setTargets(this.courseExceptionTargets);
        this.PlanningGroupTargetService.init();
    }

    save () {
        this.PlanningGroupTargetService.save().then(() => this.uibModalInstance.close());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/planningGroup/target/exception/add/index.js